
import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import ExitDateChart from '@/components/charts/ExitDateChart';
import { Review } from '@/lib/types';

interface RiskAssessmentDialogProps {
  showFullChart: boolean;
  setShowFullChart: (show: boolean) => void;
  reviews: Review[];
  onExpandChart?: () => void;
}

const RiskAssessmentDialog: React.FC<RiskAssessmentDialogProps> = ({
  showFullChart,
  setShowFullChart,
  reviews
}) => {
  return (
    <Dialog open={showFullChart} onOpenChange={setShowFullChart}>
      <DialogContent className="sm:max-w-3xl">
        <DialogHeader>
          <DialogTitle>Employee Exit Tracker</DialogTitle>
        </DialogHeader>
        <div className="pt-2">
          <ExitDateChart reviews={reviews} />
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default RiskAssessmentDialog;
